import { useStore } from '@/state/store';
import { applyFormat } from '@/engine/pipeline';
import { FORMAT_LIST } from '@/lib/formats';

export function FormatSelector() {
  const format = useStore((s) => s.format);

  return (
    <div className="flex flex-wrap items-center gap-1">
      {FORMAT_LIST.map((def) => (
        <button
          key={def.id}
          type="button"
          onClick={() => void applyFormat(def.id)}
          title={`${def.label} — ${def.width}×${def.height}`}
          className={`rounded-md px-2.5 py-1.5 text-[11px] transition ${
            format === def.id
              ? 'bg-accent text-ink-950'
              : 'bg-white/[0.03] text-ink-300 hover:bg-white/[0.07]'
          }`}
        >
          {def.label}
          <span className="ml-1.5 opacity-60">{def.short}</span>
        </button>
      ))}
    </div>
  );
}
